import { createContext, type ReactNode } from 'react';

export type OpenXAgentMenuContextType = {
  navigateTo: (content: ReactNode, title: string) => void;
  navigateBack: () => void;
};

export const OpenXAgentMenuContext = createContext<OpenXAgentMenuContextType>({
  navigateTo: () => void 0,
  navigateBack: () => void 0,
});
